.left-column {
    padding: 60px 80px;
    width: 50%;
    box-sizing: border-box;
}

.content-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.form-container {
    display: flex;
    flex-direction: column;
    gap: 32px;
}

.progress {
    max-width: 100px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.animation {
    width: 50%;
    background-color: var(--animation-bg-color);
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    overflow: hidden;
    position: sticky;
    top: 0;
}

.animation > * {
    max-width: 100%;
    max-height: 100%;
    width: 100%;
    height: 100%;
}

.nutshell-logo {
    width: 160px;
    aspect-ratio: 160/24;
}

/* Mobile styles */
@media (max-width: 768px) {
    .animation {
        display: none;
    }

    .left-column {
        width: 100%;
        padding: 30px 40px;
        min-width: 300px;
    }

    .form-container {
        gap: 16px;
        padding-bottom: 80px;
    }
}
